import { GridButtons } from "@/controls/buttons/GridButtons";
import type { WaterAllocationTarget } from "@/shared/models/WaterAccount";
import type { ColDef, ICellRendererParams } from "ag-grid-community";
import type { WaterAccountAllocationRow } from "../models/WaterAccountAllocationDraft";

const formatPercent = (value: number | null | undefined) =>
	value === null || value === undefined
		? ""
		: `${value.toLocaleString("en-US", { maximumFractionDigits: 2 })}%`;

type Props = {
	targets: WaterAllocationTarget[];
	setSelectedRowData: (row: WaterAccountAllocationRow) => void;
	setShowModal: (modal: "update" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	targets,
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const targetColumns: ColDef[] = targets.map((target) => ({
		colId: `target-${target.TargetId}`,
		headerName: target.TargetName,
		minWidth: 110,
		flex: 1,
		sortable: false,
		filter: false,
		type: "rightAligned",
		valueGetter: (params: any) =>
			(params.data as WaterAccountAllocationRow)?.PercentByTargetId[
				target.TargetId
			] ?? null,
		valueFormatter: (params: any) => formatPercent(params.value),
	}));

	const columnDefs: ColDef[] = [
		{
			field: "AccountNumber",
			headerName: "Account #",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "Location",
			headerName: "Location",
			flex: 2,
			minWidth: 180,
		},
		...targetColumns,
		{
			field: "TotalPercent",
			headerName: "Total",
			minWidth: 110,
			flex: 1,
			sortable: false,
			filter: false,
			type: "rightAligned",
			valueFormatter: (params) =>
				params.value === null ? "Not split" : formatPercent(params.value),
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as WaterAccountAllocationRow,
				edit: true,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "waterAllocationsContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 220,
			filter: false,
			autoHeaderHeight: true,
		},
	];

	return { columnDefs };
};
